import React, {useEffect} from 'react';
import { Outlet,Link } from 'react-router-dom';
//import classNames from 'classnames';
 import AdminSidebar from '../components/Navbar/AdminSidebar'
import AdminHeader from './AdminHeader'
import { useNavigate } from "react-router-dom"
import paths from "../routes/paths"
import {getAuthToken } from '../utils/auth';
import { useDispatch,useSelector } from 'react-redux';
import { ThunkDispatch } from '@reduxjs/toolkit';
import { getLoginDetails } from '../redux/slices/AuthSlice';

const AdminLayout = () => {
 // const { hash, pathname } = useLocation();
    const token = getAuthToken();
    const dispatch = useDispatch<ThunkDispatch<any,any,any>>();
    const navigate = useNavigate();

    const {loggedInUser,loading} = useSelector((state:any) => state.auth)
  // if (loggedInUser === null) {
  //     return <Navigate replace={true} to="/" />
  // }

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  // }, [pathname]);

   useEffect(() => {
      const getLoggedinDetails = () => {
        //console.log("logged in user", loggedInUser, loggedInUser === null)
        //console.log("token", token)
          if(loggedInUser === null){
              if(token && token !== ''){
                  dispatch(getLoginDetails());
              }
              else{
                navigate(paths.home);
              }
          }
        }
      getLoggedinDetails();
      
    },[loggedInUser,dispatch,token])
  
  //console.log("ssssss", loggedInUser,token)
  return (
    <>
        { !loading &&  (loggedInUser !== null  && loggedInUser?.loginType === 'Admin' ) && (
           <div className="page-wraper"> 
           <AdminHeader/>  
           {/* <AdminSidebar/>   */}
           <Outlet/>
         </div> 
        )}

    </>
   
  );
};

export default AdminLayout;
